<!-- <div class="w-full max-w-full overflow-x-hidden p-2 md:p-4 bg-white" *ngIf="report as r; else noData" id="print-section">
  <div class="border border-slate-200 bg-white p-2 rounded-md shadow-sm mb-2">
    <div class="flex justify-between items-center mb-1 gap-2">
      <span class="text-base font-semibold text-slate-900 uppercase tracking-tight">Proposal Report</span>
      <button 
        ngxPrint 
        printSectionId="print-section" 
        [useExistingCss]="true"
        class="no-print px-3 py-1 bg-indigo-600 text-white rounded font-semibold flex items-center gap-1 text-xs shadow">
        <i class="pi pi-print"></i> Print
      </button>
    </div>
    <div class="flex flex-wrap gap-x-3 gap-y-1  text-slate-700 border-t pt-2 border-slate-100">
      <div><span class="font-bold text-slate-800 uppercase text-[14px]">Name:</span> {{ r.proposal?.name || '—' }}</div>
     
    </div>
  </div>

  <div class="mt-4 flex flex-col">
    <ng-container *ngFor="let step of r.steps">
      <ng-container *ngIf="step.status.is_present">

        <div class=" flex flex-col">
          <ng-container *ngFor="let sec of getSections(step)">
            <ng-container *ngIf="sec.fields?.length > 0">
              <div class=" rounded-lg border border-slate-200 bg-white shadow-sm" >
                <table class="w-full table-auto">
                  <tbody class="divide-y divide-slate-100">
                    <ng-container *ngFor="let f of sec.fields">
                      <tr *ngIf="!isEmptyValue(f.value)" class="hover:bg-slate-50/50 transition-colors">
                        <td class="w-1/3 bg-slate-50/30 px-4 py-2.5 text-[11px] font-bold text-slate-500 uppercase border-r border-slate-50 align-middle">
                          {{ f.label }}
                        </td>
                        <td class="w-2/3 px-4 py-2.5 text-sm text-slate-700 align-top break-all ">
                          
                          <div *ngIf="f.type === 'html'" [innerHTML]="f.value"  class="editor-preview prose prose-sm max-w-none break-words  text-xs"></div>
    
                          <div *ngIf="f.type === 'date' && f.value" class="font-medium text-slate-900">
                            {{ f.value | date:'dd-MMM-y' }}
                          </div>
    
                          <div *ngIf="f.type === 'number'" class="font-mono font-bold text-indigo-600">
                            {{ asNumber(f.value) }}
                          </div>
    
                          <div *ngIf="f.type === 'list'" class="flex flex-col gap-1.5">
                            <div class="rounded-md border border-slate-100 bg-slate-50 px-2 py-1.5 text-[11px] font-medium text-slate-600 shadow-sm" *ngFor="let it of f.value">
                              <i class="pi pi-info-circle mr-1 text-[10px] text-slate-400"></i>
                              {{ it?.name || it?.email || it?.phone_number || (it | json) }}
                            </div>
                          </div>
    
                          <div *ngIf="f.type === 'text' || f.type === 'unknown'" class="leading-relaxed">
                            {{ f.value }}
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>

             
            </ng-container>
          </ng-container>
          <app-comment-thread [threads]="step.comments.threads"></app-comment-thread>
          <br>
        </div>
      </ng-container>
     

    </ng-container>
  </div>
</div>

<ng-template #noData>
  <div class="min-h-screen bg-slate-50 p-6 text-center text-sm text-slate-600">
    No report data. Please pass apiResponse input.
  </div>
</ng-template> -->


<div id="print-section">
  <div class="border border-slate-200 bg-white p-2 rounded-md shadow-sm mb-2">
    <div class="flex justify-between items-center mb-1 gap-2">
      <span class="text-base font-semibold text-slate-900 uppercase tracking-tight">Proposal Report</span>
      <button 
        ngxPrint 
        printSectionId="print-section" 
        [useExistingCss]="true"
        class="no-print px-3 py-1 bg-indigo-600 text-white rounded font-semibold flex items-center gap-1 text-xs shadow">
        <i class="pi pi-print"></i> Print
      </button>
    </div>
    <div class="flex flex-wrap gap-x-3 gap-y-1  text-slate-700 border-t pt-2 border-slate-100">
      <div><span class="font-bold text-slate-800 uppercase text-[14px]">Name:</span> {{ apiResponse.proposal?.name || '—' }}</div>
     
    </div>
  </div>


  <ng-container *ngFor="let item of apiResponse.steps">

    <app-view-from [keys]="key[item.step_code]" [data]="item.data">
    </app-view-from>
    
    <app-comment-thread [threads]="item.comments">
    </app-comment-thread>
    <app-comment-thread [threads]="item.editor_users">
    </app-comment-thread>

  </ng-container>

</div>

